import { AMCHART_FAKE_KEY } from '@/constants'

// let am4core: typeof import('@amcharts/amcharts4/core')
// let am4charts: typeof import('@amcharts/amcharts4/charts')
// let am4maps: typeof import('@amcharts/amcharts4/maps')

// const asyncAmcharts = () => {
//   Promise.all([
//   import('@amcharts/amcharts4/core'),
//   import('@amcharts/amcharts4/charts'),
//   import('@amcharts/amcharts4/maps'),
//   import('@amcharts/amcharts4/themes/animated')
//   ]).then((modules) => {
//     am4core = modules[0]
//     am4charts = modules[1]
//     am4maps = modules[2]
//     const am4themesAnimated = modules[3].default

//     am4core.addLicense(AMCHART_FAKE_KEY)
//     am4core.useTheme(am4themesAnimated)

//     return { am4core, am4charts, am4maps }

//   // Chart code goes here
//   }).catch((e) => {
//     console.error('Error when creating chart', e)
//   })
// }
// asyncAmcharts()

// export { am4core }
// export { am4charts }
// export { am4maps }

import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import * as am4maps from '@amcharts/amcharts4/maps'

import am4themes_animated from '@amcharts/amcharts4/themes/animated'

const syncAmcharts = () => {
  am4core.addLicense(AMCHART_FAKE_KEY)
  am4core.useTheme(am4themes_animated)
  am4core.options.autoDispose = true

  return { am4core, am4charts, am4maps }
}

syncAmcharts()

export { am4core, am4charts, am4maps }
